import { motion } from "framer-motion";
import "./NextLevel.css";
import { Link } from "react-router-dom";

export default function NextLevel() {
  return (
    <motion.section
      className="next-level"
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="next-level-content">
        <h2>
          Are You Ready to Take Your Badminton to the <span>Next Level?</span>
        </h2>

        <p>
          Whether you're picking up a racket for the first time or chasing that perfect smash,
          <strong> SmashKaro Badminton </strong> invites you to join our 
          <span className="highlight"> high-energy, inclusive </span> coaching sessions.
          Designed to make you confident, fast, and fearless on the court, our programs balance 
          fun and focus — ensuring you improve while enjoying every rally.
        </p>

        <p>
          Great players aren’t born — they’re trained. Our weekly sessions are built to help you
          master <strong>technique, stamina, and strategy</strong> in a friendly, competitive environment.
          Each hour takes you one step closer to your personal best — and we’ll be right there with you,
          every serve, every shot, every victory.
        </p>

        {/* ✅ Redirects to Availability Form */}
        <Link to="/availability" className="hero-btn">Enroll Now</Link>
      </div>

      <div className="next-level-bg"></div>
    </motion.section>
  );
}
